import type { RouteObject } from 'react-router';
import { Suspense } from 'react';

import { Layout as AuthClassicLayout } from 'src/layouts/auth/classic-layout';
import Error401Page from 'src/pages/401';
import Error404Page from 'src/pages/404';
import Error500Page from 'src/pages/500';
import ContactPage from 'src/pages/contact';
import CheckoutPage from 'src/pages/checkout';
import StarterPayPage from 'src/pages/starter-pay';
import StarterPayAccountPage from 'src/pages/starter-pay-account';
import StarterPayOnboardingPage from 'src/pages/starter-pay-onboarding';
import StarterPayCustomPlanBuilderPage from 'src/pages/starter-pay-custom-plan-builder';
import ResetPassword from 'src/pages/auth/jwt/reset-password';
import ForgotPassword from 'src/pages/auth/jwt/forgot-password';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import StripeConnectRedirect from 'src/pages/auth/jwt/stripe-connect-redirect';
import { Layout as ClassicLayout } from "src/layouts/auth/classic-layout";

export const routes: RouteObject[] = [
  ...authRoutes,
  ...dashboardRoutes,
  {
    path: 'forgot-password',
    element: <AuthClassicLayout>
                <Suspense>
                  <ForgotPassword />
                </Suspense>
              </AuthClassicLayout>
  },
  {
    path: 'reset-password/:token',
    element: <AuthClassicLayout>
                <Suspense>
                  <ResetPassword />
                </Suspense>
              </AuthClassicLayout>
  },
  {
    path: 'checkout',
    element: <CheckoutPage />
  },
  {
    path: 'stripe-connect-redirect',
    element: <ClassicLayout>
                <StripeConnectRedirect />
              </ClassicLayout>
  },
  {
    path: 'contact',
    element: <ContactPage />
  },
  {
    path: 'starter-pay',
    element: <StarterPayPage />
  },
  {
    path: 'starter-pay-account',
    element: <StarterPayAccountPage />
  },
  {
    path: 'starter-pay-onboarding',
    element: <StarterPayOnboardingPage />
  },
  {
    path: 'starter-pay-custom-plan-builder',
    element: <StarterPayCustomPlanBuilderPage />
  },
  {
    path: '401',
    element: <Error401Page />
  },
  {
    path: '404',
    element: <Error404Page />
  },
  {
    path: '500',
    element: <Error500Page />
  },
  {
    path: '*',
    element: <Error404Page />
  }
];
